module.exports = __webpack_public_path__ + "img/saks.74241433.jpg";